import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { CheckCircle } from '@obosbbl/grunnmuren-icons-react';
import { scorecardsRouteRef } from './routes';

/**
 * Frontend module for the upstream `tech-insights` plugin that overrides its
 * `page:tech-insights` extension with the Blueprint Scorecards page. Built as
 * a module (rather than replacing the plugin itself via `withOverrides`) so
 * the app package only needs to register this module, instead of wiring up
 * the Tech Insights override (and its routeRef) directly in `App.tsx`.
 */
export const scorecardsModule = createFrontendModule({
  pluginId: 'tech-insights',
  extensions: [
    techInsightsPlugin.getExtension('page:tech-insights').override({
      params: {
        title: 'Scorecards',
        icon: <CheckCircle />,
        routeRef: scorecardsRouteRef,
        noHeader: true,
        loader: () =>
          import('./components/ScorecardsPage').then(m => <m.ScorecardsPage />),
      },
    }),
    // The upstream Scorecards entity card hardcodes its title as an `<h5>`.
    // Override the card loader so the title renders as an `<h3>` like the other
    // entity cards (see `ScorecardsEntityCard`).
    techInsightsPlugin
      .getExtension('entity-card:tech-insights/scorecards')
      .override({
        params: {
          loader: () =>
            import('./components/ScorecardsEntityCard').then(m =>
              compatWrapper(<m.ScorecardsEntityCard title="Scorecards" />),
            ),
        },
      }),
  ],
});
